import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Custom hook to get current language and listen to language changes
 * Returns the current language code and triggers re-renders when language changes
 */
export const useLanguage = () => {
  const { i18n } = useTranslation();
  const [currentLanguage, setCurrentLanguage] = useState(i18n.language || 'en');

  useEffect(() => {
    const handleLanguageChange = (lng) => {
      setCurrentLanguage(lng);
      // Update localStorage to keep it in sync
      localStorage.setItem('i18nextLng', lng);
    };

    // Listen to i18n language changes
    i18n.on('languageChanged', handleLanguageChange);

    // Set initial language
    setCurrentLanguage(i18n.language || localStorage.getItem('i18nextLng') || 'en');

    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, [i18n]);

  return currentLanguage;
};

